import React, {memo, useEffect, useState} from "react";
import {LabelTextControl} from "../index";

interface LabelTextProps {
    editor: any;
    value: string;
    putData: (data: string) => void;
    labelText: string;
}

const LabelText = (props: LabelTextProps) => {
    const [value, setValue] = useState(LabelTextControl.DEFAULT_VALUE);

    const handleOnBlur = () => {
        props.editor.trigger("process");
    };

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
        props.putData(event.target.value);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className="text-control">
            <div className="text-control-label">
                {props.labelText}
            </div>
            <input
                className="text-control-input"
                type="text"
                value={value}
                onPointerDown={e => e.stopPropagation()}
                onChange={handleOnChange}
                onBlur={handleOnBlur}/>
        </div>
    )
};

export default memo(LabelText)